import { HeadContent, Outlet, Scripts, createRootRoute } from '@tanstack/react-router'

import appCss from '../styles.css?url'
import '@fontsource-variable/inter'
import { AnalyticsProvider } from '@/components/AnalyticsProvider'

const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID
const gscVerification = import.meta.env.VITE_GSC_VERIFICATION
const isGaEnabled = Boolean(gaMeasurementId) && !import.meta.env.DEV

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: 'Patriar | Holdings Patrimoniais e Contabilidade' },
      { name: 'description', content: 'Crie sua holding patrimonial e proteja seus imóveis. Redução de impostos, planejamento sucessório e contabilidade especializada para famílias brasileiras.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: 'pt_BR' },
      { property: 'og:site_name', content: 'Patriar' },
      { name: 'twitter:card', content: 'summary_large_image' },
      ...(gscVerification
        ? [{ name: 'google-site-verification', content: gscVerification }]
        : []),
    ],
    links: [
      { rel: 'stylesheet', href: appCss },
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      { rel: 'alternate', type: 'application/rss+xml', title: 'Patriar Blog RSS', href: '/api/rss' },
    ],
    scripts: isGaEnabled
      ? [
          {
            src: `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`,
            async: true,
          },
          {
            children: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${gaMeasurementId}',{send_page_view:false});`,
          },
        ]
      : [],
  }),
  component: RootComponent,
})

function RootComponent() {
  return (
    <html lang="pt-BR" className="scroll-smooth">
      <head>
        <HeadContent />
      </head>
      <body className="min-h-screen bg-white text-navy-900 antialiased">
        <Outlet />
        <AnalyticsProvider />
        {/*{import.meta.env.DEV && (
        <TanStackDevtools
            config={{ position: 'bottom-right' }}
            plugins={[{
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            }]}
          />
        )}*/}
        <Scripts />
      </body>
    </html>
  )
}
